module.exports = __webpack_public_path__ + "themes/mf/img/prize-5.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-5.png
// module id = 94
// module chunks = 3